import React from "react";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import LinkIcon from "@material-ui/icons/Link";
import AccountBoxOutlinedIcon from "@material-ui/icons/AccountBoxOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import EventNoteOutlinedIcon from "@material-ui/icons/EventNoteOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import ListAltOutlinedIcon from "@material-ui/icons/ListAltOutlined";
import PersonOutlinedIcon from "@material-ui/icons/PersonOutlined";
import DirectionsCarOutlinedIcon from "@material-ui/icons/DirectionsCarOutlined";
import RvHookupOutlinedIcon from "@material-ui/icons/RvHookupOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";

export const MenuItems = [{
  url: '/order',
  name: 'Перевозки',
  icon: <EventNoteOutlinedIcon />
}, {
  url: '/planning',
  name: 'Планирование',
  icon: <AssignmentOutlinedIcon />
}, {
  url: '/timetable',
  name: 'Статус ТС',
  icon: <LocalShippingOutlinedIcon />
}, {
  url: '/schedule',
  name: 'Расписание',
  icon: <LinkIcon />
}, {
  url: '/driver',
  name: 'Водители',
  icon: <PersonOutlinedIcon />
}, {
  url: '/tractor_unit',
  name: 'ТС',
  icon: <DirectionsCarOutlinedIcon />
}, {
  url: '/semi_trailer',
  name: 'Полуприцепы',
  icon: <RvHookupOutlinedIcon />
}, {
  url: '/client',
  name: 'Клиенты',
  icon: <AccountBoxOutlinedIcon />
}, {
  url: '/tariff',
  name: 'Тарифы',
  icon: <PaymentOutlinedIcon />
}, {
  url: '/point',
  name: 'Точки',
  icon: <RoomOutlinedIcon />
}, {
  url: '/service',
  name: 'Услуги',
  icon: <CategoryOutlinedIcon />
}, {
  url: '/catalog/choice',
  name: 'Справочники',
  icon: <ListAltOutlinedIcon />
}];